import { enhanceReagendarAtividade } from './enhanceReagendarAtividade';
import { RescheduleActionDialog } from './RescheduleActionDialog';

export const ReagendamentoAtividadeDialogContainer = enhanceReagendarAtividade(
  'REAGENDAR_ATIVIDADE'
)(RescheduleActionDialog);
